export const mailFilter = "DlXHzc";
export const allFilter = "BnX6te";
export const sortBySize = "gihxLe";
export default {mailFilter,allFilter,sortBySize};